export const DEFAULT_OPTIONS = {
  modifiers: [
    {
      name: 'arrow',
      options: { element: '.step__arrow', padding: 10 },
    },
    {
      name: 'preventOverflow',
      options: {
        rootBoundary: 'window',
      },
    },
    {
      name: 'offset',
      options: {
        offset: [0, 15],
      },
    },
  ],
  placement: 'bottom',
}
